import styles from './CounterList.module.css';
import { Link } from 'react-router-dom';
import { getTimeMilliseconds } from '../../helper';
import { deleteLoginWebListItemBd, editsLoginWebCounterBd } from '../../firebase';
import { useState } from 'react';
import { pathHome } from '../../path';

export default function CounterList(webCounterList, restartPage) {
  const [showPopup, setShowPoup] = useState(false);
  const [resetObject, setResetObject] = useState({
    counterAll: true,
    counterAllTimeGroup: false,
    counterAllTime: false,
  });

  let timeViewMillisecondsAllTime = 0;
  let clientSCounter = 0;
  let allViews = 0;
  let android = 0;
  let androidViews = 0;
  let ios = 0;
  let iosViews = 0;
  let windows = 0;
  let windowsViews = 0;
  let other = 0;
  let otherViews = 0;
  let timeCounter = 0;

  // Обнуляє активність
  const restartCounter = (webCounterList, resetObject) => {
    if (resetObject.counterAll || resetObject.counterAllTimeGroup || resetObject.counterAllTime) {
      let isDelet = window.confirm('Видалити дані активності?');

      if (isDelet) {
        const restartCounterItems = async (client_id, updateObject, deleteList) => {
          await editsLoginWebCounterBd(client_id, updateObject);
          if (deleteList) {
            await deleteLoginWebListItemBd(client_id);
          }
        };

        let updateObject = {};
        let deleteList = false;

        if (resetObject.counterAll) {
          updateObject.counterAll = 0;
          updateObject.counterAndroid = 0;
          updateObject.counterIos = 0;
          updateObject.loginCounterIos = 0;
          updateObject.loginCounterWindows = 0;
          updateObject.counterWindows = 0;
          updateObject.counterOther = 0;
          updateObject.loginCounterDey = 0;
          updateObject.timeViewMilliseconds = 0;
          deleteList = true;
        }
        if (resetObject.counterAllTimeGroup) {
          updateObject.counterAllTimeGroup = 0;
          updateObject.timeViewMillisecondsGropTime = 0;
          updateObject.loginCounterAllGroup = 0;
        }
        if (resetObject.counterAllTime) {
          updateObject.counterAllTime = 0;
          updateObject.timeViewMillisecondsAllTime = 0;
          updateObject.loginCounterAll = 0;
          updateObject.loginCounterAllTime = 0;

          updateObject.loginCounterAndroidAllTime = 0;
          updateObject.loginCounterIosAllTime = 0;
          updateObject.loginCounterWindowsAllTime = 0;
        }

        webCounterList.forEach((element) => {
          // При обнулені  статистики за день обнуляти на бекенді тільки в тих в кого вона є
          if (
            resetObject.counterAll &&
            !resetObject.counterAllTimeGroup &&
            !resetObject.counterAllTime &&
            (element.counterAll || element.loginCounterDey)
          ) {
            restartCounterItems(element.client_id, updateObject, deleteList);
          }

          if (resetObject.counterAllTimeGroup || resetObject.counterAllTime) {
            restartCounterItems(element.client_id, updateObject, deleteList);
          }
        });
        restartPage();
        setShowPoup(false);
      }
    } else {
      alert('Виберіть дані які хочете видалити.');
    }
  };

  const items = webCounterList.map((item, index) => {
    clientSCounter++;
    timeViewMillisecondsAllTime =
      timeViewMillisecondsAllTime + Number(item.timeViewMillisecondsAllTime);
    allViews = allViews + Number(item.counterAll);
    androidViews = androidViews + Number(item.counterAndroid);
    iosViews = iosViews + Number(item.counterIos);
    windowsViews = windowsViews + Number(item.counterWindows);
    otherViews = otherViews + Number(item.counterOther);
    timeCounter = timeCounter + Number(item.timeViewMilliseconds);

    if (item.counterAndroid > 0) {
      android++;
    }
    if (item.counterIos > 0) {
      ios++;
    }
    if (item.counterWindows > 0) {
      windows++;
    }
    if (item.counterOther > 0) {
      other++;
    }
    return (
      <Link
        key={item.client_id}
        className={styles.btn_link}
        to={`/${pathHome}/userActivity/${item.client_id}`}>
        <div className={styles.item_wrapper}>
          <div className={styles.viewTime}>
            <div
              className={
                item.timeViewMilliseconds
                  ? styles.viewTime_item
                  : styles.viewTime_item + ' ' + styles.counterNull
              }>
              <span className={styles.timeViewMilliseconds}>{index + 1})</span> За день{' '}
              {getTimeMilliseconds(item.timeViewMilliseconds)}{' '}
              <span
                className={
                  item.timeViewMilliseconds
                    ? styles.viewTime_item
                    : styles.viewTime_item + ' ' + styles.counterNull
                }>
                ({item.counterAll}){' '}
              </span>
            </div>
            <div
              className={
                item.timeViewMillisecondsGropTime
                  ? styles.viewTime_item + ' ' + styles.timeViewMilliseconds
                  : styles.viewTime_item +
                    ' ' +
                    styles.timeViewMilliseconds +
                    ' ' +
                    styles.counterNull
              }>
              В групі {getTimeMilliseconds(item.timeViewMillisecondsGropTime)} (
              {item.counterAllTimeGroup})
            </div>

            <div
              className={
                item.timeViewMillisecondsAllTime
                  ? styles.viewTime_item + ' ' + styles.timeViewMilliseconds
                  : styles.viewTime_item +
                    ' ' +
                    styles.timeViewMilliseconds +
                    ' ' +
                    styles.counterNull
              }>
              Весь час {getTimeMilliseconds(item.timeViewMillisecondsAllTime)} (
              {item.counterAllTime})
            </div>
          </div>

          <div className={styles.fullName}>{item.fullName}</div>
          <div className={styles.counter_item_wrapper}>
            Всі
            <div className={styles.value}>
              {item.loginCounterDey ? item.loginCounterDey : 0}/{item.counterAll}
            </div>
          </div>
          <div
            className={
              item.counterAndroid > 0
                ? styles.counter_item_wrapper
                : styles.counter_item_wrapper + ' ' + styles.counter_item_wrapper_noActive
            }>
            <svg
              height="20px"
              width="20px"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 511.797 511.797"
              xmlSpace="preserve">
              <g transform="translate(0 1)">
                <g>
                  <path
                    style={{
                      fill: '#B3CD4B',
                    }}
                    d="M386.068,128.967H125.729C129.2,91.652,165.648,24.831,256.766,24.831 C343.546,24.831,382.597,91.652,386.068,128.967"
                  />
                  <path
                    style={{
                      fill: '#B3CD4B',
                    }}
                    d="M56.305,354.594L56.305,354.594c-19.092,0-34.712-15.62-34.712-34.712V198.391 c0-19.092,15.62-34.712,34.712-34.712s34.712,15.62,34.712,34.712v121.492C91.017,338.974,75.397,354.594,56.305,354.594"
                  />
                  <path
                    style={{
                      fill: '#B3CD4B',
                    }}
                    d="M455.492,354.594L455.492,354.594c-19.092,0-34.712-15.62-34.712-34.712V198.391 c0-19.092,15.62-34.712,34.712-34.712c19.092,0,34.712,15.62,34.712,34.712v121.492 C490.204,338.974,474.583,354.594,455.492,354.594"
                  />
                  <path
                    style={{
                      fill: '#B3CD4B',
                    }}
                    d="M351.356,397.984v86.78c0,14.753-11.281,26.034-26.034,26.034 c-14.753,0-26.034-11.281-26.034-26.034v-86.78h-86.78v86.78c0,14.753-12.149,26.034-26.034,26.034s-26.034-11.281-26.034-26.034 v-86.78h-34.712V163.679h260.339v234.305H351.356z"
                  />
                </g>
                <g>
                  <path
                    style={{
                      fill: '#FFFFFF',
                    }}
                    d="M229.865,85.577c0-9.546-7.81-17.356-17.356-17.356c-9.546,0-17.356,7.81-17.356,17.356 s7.81,17.356,17.356,17.356C222.055,102.933,229.865,95.123,229.865,85.577"
                  />
                  <path
                    style={{
                      fill: '#FFFFFF',
                    }}
                    d="M316.644,85.577c0-9.546-7.81-17.356-17.356-17.356s-17.356,7.81-17.356,17.356 s7.81,17.356,17.356,17.356C308.834,102.933,316.644,95.123,316.644,85.577"
                  />
                </g>
                <g>
                  <path
                    style={{
                      fill: '#B3CD4B',
                    }}
                    d="M185.607,50.865c-3.471,0-6.075-1.736-7.81-5.207l-16.488-34.712 c-1.736-4.339,0-9.546,4.339-11.281c4.339-1.736,9.546,0,11.281,4.339l16.488,34.712c1.736,4.339,0,9.546-4.339,11.281 C188.211,49.997,187.343,50.865,185.607,50.865z"
                  />
                  <path
                    style={{
                      fill: '#B3CD4B',
                    }}
                    d="M325.322,50.865c-0.868,0-2.603,0-3.471-0.868c-4.339-1.736-6.075-6.942-4.339-11.281L334,4.004 c1.736-4.339,6.942-6.075,11.281-4.339c4.339,1.736,6.075,6.942,4.339,11.281l-16.488,34.712 C332.265,49.129,328.794,50.865,325.322,50.865z"
                  />
                </g>
              </g>
            </svg>
            <div className={styles.value}>{item.counterAndroid}</div>
          </div>
          <div
            className={
              item.counterIos > 0
                ? styles.counter_item_wrapper
                : styles.counter_item_wrapper + ' ' + styles.counter_item_wrapper_noActive
            }>
            <svg
              width="20px"
              height="20px"
              viewBox="-1.5 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink">
              <title>{'apple [#173]'}</title>
              <desc>{'Created with Sketch.'}</desc>
              <defs />
              <g id="Page-1" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                <g
                  id="Dribbble-Light-Preview"
                  transform="translate(-102.000000, -7439.000000)"
                  fill="#000000">
                  <g id="icons" transform="translate(56.000000, 160.000000)">
                    <path
                      d="M57.5708873,7282.19296 C58.2999598,7281.34797 58.7914012,7280.17098 58.6569121,7279 C57.6062792,7279.04 56.3352055,7279.67099 55.5818643,7280.51498 C54.905374,7281.26397 54.3148354,7282.46095 54.4735932,7283.60894 C55.6455696,7283.69593 56.8418148,7283.03894 57.5708873,7282.19296 M60.1989864,7289.62485 C60.2283111,7292.65181 62.9696641,7293.65879 63,7293.67179 C62.9777537,7293.74279 62.562152,7295.10677 61.5560117,7296.51675 C60.6853718,7297.73474 59.7823735,7298.94772 58.3596204,7298.97372 C56.9621472,7298.99872 56.5121648,7298.17973 54.9134635,7298.17973 C53.3157735,7298.17973 52.8162425,7298.94772 51.4935978,7298.99872 C50.1203933,7299.04772 49.0738052,7297.68074 48.197098,7296.46676 C46.4032359,7293.98379 45.0330649,7289.44985 46.8734421,7286.3899 C47.7875635,7284.87092 49.4206455,7283.90793 51.1942837,7283.88393 C52.5422083,7283.85893 53.8153044,7284.75292 54.6394294,7284.75292 C55.4635543,7284.75292 57.0106846,7283.67793 58.6366882,7283.83593 C59.3172232,7283.86293 61.2283842,7284.09893 62.4549652,7285.8199 C62.355868,7285.8789 60.1747177,7287.09489 60.1989864,7289.62485"
                      id="apple-[#173]"
                    />
                  </g>
                </g>
              </g>
            </svg>
            <div className={styles.value}>{item.counterIos}</div>
          </div>
          <div
            className={
              item.counterWindows > 0
                ? styles.counter_item_wrapper
                : styles.counter_item_wrapper + ' ' + styles.counter_item_wrapper_noActive
            }>
            <svg
              fill="#5372ff"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="20px"
              height="20px"
              viewBox="0 0 512 512"
              xmlSpace="preserve">
              <g id="7935ec95c421cee6d86eb22ecd13295e">
                <path
                  style={{
                    display: 'inline',
                  }}
                  d="M106.669,52.438c0,0,102.123-55.525,189.491,11.392l-48.896,167.995 c0,0-54.756-37.67-95.361-33.602c-40.605,4.079-94.13,23.508-94.13,23.508L106.669,52.438z M0.5,420.566 c22.54-11.653,56.372-17.559,95.35-20.823c39.011-3.255,93.91,32.468,93.91,32.468l49.401-169.776 c-7.817-5.618-44.168-30.094-89.666-33.348c-45.52-3.255-100.354,22.243-100.354,22.243L0.5,420.566z M216.104,447.165 c8.928,3.519,38.22,31.38,86.972,33.854c48.763,2.419,102.541-22.749,102.541-22.749s47.894-167.6,48.861-168.249 c0.33-0.176-0.604,0.484-0.968,0.649c-45.596,17.845-68.872,20.506-102.496,21.309c-34.141,0.824-86.269-33.095-86.269-33.095 L216.104,447.165z M322.01,81.575l-48.995,167.017c0,0,39.803,39,95.867,35.768c56.098-3.267,86.532-20.945,93.976-23.442 L511.5,92.416c0,0-64.606,26.982-106.851,22.09C362.384,109.613,336.094,91.657,322.01,81.575z"
                />
              </g>
            </svg>
            <div className={styles.value}>{item.counterWindows}</div>
          </div>
          <div
            className={
              item.counterOther > 0
                ? styles.counter_item_wrapper
                : styles.counter_item_wrapper + ' ' + styles.counter_item_wrapper_noActive
            }>
            ?<div className={styles.value}>{item.counterOther}</div>
          </div>
        </div>
      </Link>
    );
  });

  // console.log('--webCounterList--- === ', webCounterList);
  // console.log('timeViewMillisecondsAllTime === ', timeViewMillisecondsAllTime);
  // console.log('clientSCounter === ', clientSCounter);
  // console.log('allViews === ', allViews);
  // console.log('android === ', android);
  // console.log('androidViews === ', androidViews);
  // console.log('ios === ', ios);
  // console.log('iosViews === ', iosViews);
  // console.log('windows === ', windows);
  // console.log('clientSCounter === ', clientSCounter);
  // console.log('other === ', other);
  // console.log('otherViews === ', otherViews);
  // console.log('timeCounter === ', timeCounter);
  // console.log(' ----------------------------------------');

  return (
    <>
      <div className={'df gap_5 aic mb_5 '}>
        <div className={styles.timeViewMillisecondsAllTime}>
          {getTimeMilliseconds(timeViewMillisecondsAllTime)}
        </div>
        год / хв / сек
      </div>
      <div className={styles.result_wrapper}>
        <div className={styles.result_item_wrapper}>
          <div>Клієнтів</div>
          <div>{clientSCounter}</div>
        </div>
        <div
          className={styles.result_item_wrapper + ' ' + styles.button}
          onClick={() => setShowPoup(true)}>
          <svg
            className={styles.restart_svg}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 50 50"
            width="12px"
            height="12px">
            <path d="M 25 2 A 2.0002 2.0002 0 1 0 25 6 C 35.517124 6 44 14.482876 44 25 C 44 35.517124 35.517124 44 25 44 C 14.482876 44 6 35.517124 6 25 C 6 19.524201 8.3080175 14.608106 12 11.144531 L 12 15 A 2.0002 2.0002 0 1 0 16 15 L 16 4 L 5 4 A 2.0002 2.0002 0 1 0 5 8 L 9.5253906 8 C 4.9067015 12.20948 2 18.272325 2 25 C 2 37.678876 12.321124 48 25 48 C 37.678876 48 48 37.678876 48 25 C 48 12.321124 37.678876 2 25 2 z" />
          </svg>
          <div>Час</div>
          <div className={styles.timeCounter}>{getTimeMilliseconds(timeCounter)}</div>
        </div>
        <div className={styles.result_item_wrapper}>
          <div>Всі</div>
          <div>{allViews}</div>
        </div>
        <div className={styles.result_item_wrapper}>
          <div className={styles.result_item_count}>{android}</div>
          <svg
            height="20px"
            width="20px"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 511.797 511.797"
            xmlSpace="preserve">
            <g transform="translate(0 1)">
              <g>
                <path
                  style={{
                    fill: '#B3CD4B',
                  }}
                  d="M386.068,128.967H125.729C129.2,91.652,165.648,24.831,256.766,24.831 C343.546,24.831,382.597,91.652,386.068,128.967"
                />
                <path
                  style={{
                    fill: '#B3CD4B',
                  }}
                  d="M56.305,354.594L56.305,354.594c-19.092,0-34.712-15.62-34.712-34.712V198.391 c0-19.092,15.62-34.712,34.712-34.712s34.712,15.62,34.712,34.712v121.492C91.017,338.974,75.397,354.594,56.305,354.594"
                />
                <path
                  style={{
                    fill: '#B3CD4B',
                  }}
                  d="M455.492,354.594L455.492,354.594c-19.092,0-34.712-15.62-34.712-34.712V198.391 c0-19.092,15.62-34.712,34.712-34.712c19.092,0,34.712,15.62,34.712,34.712v121.492 C490.204,338.974,474.583,354.594,455.492,354.594"
                />
                <path
                  style={{
                    fill: '#B3CD4B',
                  }}
                  d="M351.356,397.984v86.78c0,14.753-11.281,26.034-26.034,26.034 c-14.753,0-26.034-11.281-26.034-26.034v-86.78h-86.78v86.78c0,14.753-12.149,26.034-26.034,26.034s-26.034-11.281-26.034-26.034 v-86.78h-34.712V163.679h260.339v234.305H351.356z"
                />
              </g>
              <g>
                <path
                  style={{
                    fill: '#FFFFFF',
                  }}
                  d="M229.865,85.577c0-9.546-7.81-17.356-17.356-17.356c-9.546,0-17.356,7.81-17.356,17.356 s7.81,17.356,17.356,17.356C222.055,102.933,229.865,95.123,229.865,85.577"
                />
                <path
                  style={{
                    fill: '#FFFFFF',
                  }}
                  d="M316.644,85.577c0-9.546-7.81-17.356-17.356-17.356s-17.356,7.81-17.356,17.356 s7.81,17.356,17.356,17.356C308.834,102.933,316.644,95.123,316.644,85.577"
                />
              </g>
              <g>
                <path
                  style={{
                    fill: '#B3CD4B',
                  }}
                  d="M185.607,50.865c-3.471,0-6.075-1.736-7.81-5.207l-16.488-34.712 c-1.736-4.339,0-9.546,4.339-11.281c4.339-1.736,9.546,0,11.281,4.339l16.488,34.712c1.736,4.339,0,9.546-4.339,11.281 C188.211,49.997,187.343,50.865,185.607,50.865z"
                />
                <path
                  style={{
                    fill: '#B3CD4B',
                  }}
                  d="M325.322,50.865c-0.868,0-2.603,0-3.471-0.868c-4.339-1.736-6.075-6.942-4.339-11.281L334,4.004 c1.736-4.339,6.942-6.075,11.281-4.339c4.339,1.736,6.075,6.942,4.339,11.281l-16.488,34.712 C332.265,49.129,328.794,50.865,325.322,50.865z"
                />
              </g>
            </g>
          </svg>
          <div>{androidViews}</div>
        </div>
        <div className={styles.result_item_wrapper}>
          <div className={styles.result_item_count}>{ios}</div>

          <svg
            width="20px"
            height="20px"
            viewBox="-1.5 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink">
            <title>{'apple [#173]'}</title>
            <desc>{'Created with Sketch.'}</desc>
            <defs />
            <g id="Page-1" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
              <g
                id="Dribbble-Light-Preview"
                transform="translate(-102.000000, -7439.000000)"
                fill="#000000">
                <g id="icons" transform="translate(56.000000, 160.000000)">
                  <path
                    d="M57.5708873,7282.19296 C58.2999598,7281.34797 58.7914012,7280.17098 58.6569121,7279 C57.6062792,7279.04 56.3352055,7279.67099 55.5818643,7280.51498 C54.905374,7281.26397 54.3148354,7282.46095 54.4735932,7283.60894 C55.6455696,7283.69593 56.8418148,7283.03894 57.5708873,7282.19296 M60.1989864,7289.62485 C60.2283111,7292.65181 62.9696641,7293.65879 63,7293.67179 C62.9777537,7293.74279 62.562152,7295.10677 61.5560117,7296.51675 C60.6853718,7297.73474 59.7823735,7298.94772 58.3596204,7298.97372 C56.9621472,7298.99872 56.5121648,7298.17973 54.9134635,7298.17973 C53.3157735,7298.17973 52.8162425,7298.94772 51.4935978,7298.99872 C50.1203933,7299.04772 49.0738052,7297.68074 48.197098,7296.46676 C46.4032359,7293.98379 45.0330649,7289.44985 46.8734421,7286.3899 C47.7875635,7284.87092 49.4206455,7283.90793 51.1942837,7283.88393 C52.5422083,7283.85893 53.8153044,7284.75292 54.6394294,7284.75292 C55.4635543,7284.75292 57.0106846,7283.67793 58.6366882,7283.83593 C59.3172232,7283.86293 61.2283842,7284.09893 62.4549652,7285.8199 C62.355868,7285.8789 60.1747177,7287.09489 60.1989864,7289.62485"
                    id="apple-[#173]"
                  />
                </g>
              </g>
            </g>
          </svg>
          <div>{iosViews}</div>
        </div>
        <div className={styles.result_item_wrapper}>
          <div className={styles.result_item_count}>{windows}</div>

          <svg
            fill="#5372ff"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="20px"
            height="20px"
            viewBox="0 0 512 512"
            xmlSpace="preserve">
            <g id="7935ec95c421cee6d86eb22ecd13295e">
              <path
                style={{
                  display: 'inline',
                }}
                d="M106.669,52.438c0,0,102.123-55.525,189.491,11.392l-48.896,167.995 c0,0-54.756-37.67-95.361-33.602c-40.605,4.079-94.13,23.508-94.13,23.508L106.669,52.438z M0.5,420.566 c22.54-11.653,56.372-17.559,95.35-20.823c39.011-3.255,93.91,32.468,93.91,32.468l49.401-169.776 c-7.817-5.618-44.168-30.094-89.666-33.348c-45.52-3.255-100.354,22.243-100.354,22.243L0.5,420.566z M216.104,447.165 c8.928,3.519,38.22,31.38,86.972,33.854c48.763,2.419,102.541-22.749,102.541-22.749s47.894-167.6,48.861-168.249 c0.33-0.176-0.604,0.484-0.968,0.649c-45.596,17.845-68.872,20.506-102.496,21.309c-34.141,0.824-86.269-33.095-86.269-33.095 L216.104,447.165z M322.01,81.575l-48.995,167.017c0,0,39.803,39,95.867,35.768c56.098-3.267,86.532-20.945,93.976-23.442 L511.5,92.416c0,0-64.606,26.982-106.851,22.09C362.384,109.613,336.094,91.657,322.01,81.575z"
              />
            </g>
          </svg>
          <div>{windowsViews}</div>
        </div>
        <div className={styles.result_item_wrapper}>
          <div className={styles.result_item_count}>{other}</div>

          <div>?</div>
          <div>{otherViews}</div>
        </div>
      </div>
      {/*  */}
      {items}

      {showPopup && (
        <div className={styles.popup_fon}>
          <div className={styles.popup_content_wrapper}>
            <div className={styles.popup_content}>
              <div className={styles.popup_item_wrapper}>
                <div>За день</div>
                <div
                  onClick={() =>
                    setResetObject({
                      ...resetObject,
                      counterAll: !resetObject.counterAll,
                    })
                  }
                  className={
                    resetObject.counterAll
                      ? styles.popup_itemSelect_active + ' ' + styles.popup_itemSelect
                      : styles.popup_itemSelect
                  }></div>
              </div>
              <div className={styles.popup_item_wrapper}>
                <div>В групі</div>
                <div
                  onClick={() =>
                    setResetObject({
                      ...resetObject,
                      counterAllTimeGroup: !resetObject.counterAllTimeGroup,
                    })
                  }
                  className={
                    resetObject.counterAllTimeGroup
                      ? styles.popup_itemSelect_active + ' ' + styles.popup_itemSelect
                      : styles.popup_itemSelect
                  }></div>
              </div>
              <div className={styles.popup_item_wrapper}>
                <div>Весь час</div>
                <div
                  onClick={() =>
                    setResetObject({
                      ...resetObject,
                      counterAllTime: !resetObject.counterAllTime,
                    })
                  }
                  className={
                    resetObject.counterAllTime
                      ? styles.popup_itemSelect_active + ' ' + styles.popup_itemSelect
                      : styles.popup_itemSelect
                  }></div>
              </div>
            </div>
            <div className={styles.popup_btn_wrapper}>
              <button
                className={styles.popup_btn + ' ' + styles.popup_reset_btn}
                onClick={() => restartCounter(webCounterList, resetObject)}>
                Обнулити
              </button>
              <button className={styles.popup_btn} onClick={() => setShowPoup(false)}>
                Відміна
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
